import Main from "./top/main.es6";
import Modal from "./top/modal.es6";
import Movie from "./top/movie.es6";
import ScrollFunc from "./top/scroll.es6";

const modal = new Modal();
const scrollfunc = new ScrollFunc();
const movie = new Movie();
const main = new Main();
